import axios from 'axios';

export default {
  validarCampo(p_email, ruta, campo, valor, valoresAdicionales) {
    // mapear nombre del campo al nombre del parametro a enviar
    var nombreParametro = campo.split("_");
    nombreParametro = 'p_' + nombreParametro[1];
    // crear objeto con el valor a enviar
    var parametros = {};
    parametros[nombreParametro] = valor;
    parametros['p_valadic'] = valoresAdicionales;
    return axios
      .post('spoc/modppentry', {
        "p_email": p_email,
        "p_metodo": ruta + "." + campo.toUpperCase(),
        "p_args_in": JSON.stringify(parametros)
      })
  },

  // obtener menu
  obtenerMenu(p_email) {
    return axios
      .post('spoc/modppentry', {
        "p_email": p_email,
        "p_metodo": "extppgrants.menus",
        "p_args_in": JSON.stringify({
          "p_mail": p_email
        })
      })
  }
}
